import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/public.css'
import 'swiper/element/bundle'
import '@/assets/fonts/iconfont.css'
// 注册 swiper 的自定义元素
import { register } from 'swiper/element/bundle'
register() // 💥 必须注册！
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
